module.exports = __webpack_public_path__ + "img/dabbing_ethan.d811a0a1.jpg";